module.exports = "<div class=nn-addon-vimeo ng-style=\"{'padding-top': aspectRatio}\"><div><iframe id=\"vimeo-player{{ vimeoSettings.item.content }}\" ng-src=\"{{ vimeoSettings.src }}\" width=100% height=100% frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-add-ons/nn-addon-vimeo/nn-addon-vimeo.directive.html
// module id = 947
// module chunks = 0